import { Box, Breadcrumbs, Button, Link, Stack, Typography } from "@mui/material";
import { MarathonForm } from "features/createEditMarathon/ui/MarathonForm";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { removeFromLocal } from "shared/services/getLocal";
import { useTranslation } from "react-i18next";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { ConfirmModal } from "shared/ui";
import { useNavigate } from "react-router-dom";

const CreateNewMarathon = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    removeFromLocal("marathonFormData");
    removeFromLocal("startNumberRanges_distance");
  }, []);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  }

  const handleConfirmLeave = () => {
    setIsModalOpen(false);
    navigate('/admin_panel/marathons');
  }
  return (
    <Box
      sx={{
        maxWidth: '600px',
        margin: '0 auto'
      }}>
      <Box sx={{
        margin: { xs: "24px" }
      }}>
        <Box
          sx={{
            padding: '16px 0'
          }}
        >
          <Stack spacing={2}>
            <Breadcrumbs
              sx={{ color: "#0090D1" }}
              separator={<NavigateNextIcon fontSize="small" />}
            >
              <Link
                underline="hover"
                color="#0090D1"
                href="/admin_panel/marathons"
                sx={{
                  fontFamily: "Raleway",
                  fontWeight: 500,
                  fontSize: "14px",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {t("marathonsPage.marathons")}
              </Link>
              <Typography
                color="text.primary"
                sx={{
                  fontFamily: "Raleway",
                  fontWeight: 500,
                  fontSize: "14px",
                }}
              >
                {t("marathonsPage.createMarathon")}
              </Typography>
            </Breadcrumbs>
          </Stack>
        </Box>
        <Box sx={{
          display: 'flex',
          justifyContent: "space-between",
        }}>
          <Typography
            sx={{
              fontFamily: "Raleway",
              fontWeight: 600,
              fontSize: "24px",
              lineHeight: "40px",
              letterSpacing: "0",
              verticalAlign: "middle",
              color: '#3E444A',
              fontVariantNumeric: "lining-nums proportional-nums",
            }}
          >{t("marathonsPage.createMarathon")}</Typography>
          <Button
            startIcon={<CloseIcon sx={{ width: '16px', height: '16px', color: "#0090D1" }} />}
            onClick={handleOpenModal}
            sx={{
              fontFamily: "Raleway",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "24px",
              letterSpacing: "0",
              textAlign: "center",
              textTransform: "none",
              padding: "8px 16px",
              borderRadius: "8px",
              color: "#0090D1"
            }}
          >
            {t("buttons.cancel")}
          </Button>
        </Box>
        <Box
          //
          className="container-adminPanel"
          sx={{ maxWidth: "600px", width: "100%", margin: "0" }}
        >
          <MarathonForm isEditMode={false} />
        </Box>
      </Box>

      <ConfirmModal
        open={isModalOpen}
        title={t("leaveModal.leavePageTitle")}
        description={t("leaveModal.leavePageDescription")}
        confirmText={t("buttons.leave")}
        cancelText={t("buttons.cancel")}
        onConfirm={handleConfirmLeave}
        onCancel={() => setIsModalOpen(false)}
      />
    </Box >
  );
};

export default CreateNewMarathon;
